<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn search-picker">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">VIN</div>
                    <el-input class="search-item" size="small" clearable style="width: 200px" v-model.trim="searchData.VIN" placeholder="请输入VIN"></el-input>
                    <div class="search-name">查询人</div>
                    <el-select v-model="searchData.SId" size="small" clearable class="search-item" filterable placeholder="请选择" @visible-change="staffVisibleChange($event)">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">查询时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
                <div class="search-ctn-right" v-if="summaryStr">
                    <div class="section-summary">
                        <div>
                            <span>{{ summaryStr }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                    <el-table-column show-overflow-tooltip prop="Request" label="查询VIN">
                        <template slot-scope="scope">
                            <el-button @click="vinSearch(scope.row.Request)" type="text" style="padding: 0px">{{ scope.row.Request }}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Sponsor" label="查询人"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Source" label="查询来源"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="OrderCount" label="绑单数"></el-table-column>
                    <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="GoodsCount" label="绑配件数"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="RequestTime" label="查询时间"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="RequestCount" label="查询次数"></el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="请求记录" size="mini" type="text" @click="opRecords(scope.row.Request)">请求记录</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="VIN快搜" :visible.sync="vinSearchVisible" width="1000px">
            <div class="dialog-content" v-if="vinSearchVisible">
                <vinSearch ref="vinSearch" :VIN="vin" @closeDialog="closeVinSearch"></vinSearch>
            </div>
        </el-dialog>
         <el-dialog :close-on-click-modal="false" title="请求记录" :visible.sync="recordVisible" width="600px">
            <div class="dialog-content" v-if="recordVisible">
                <vinReqRecord :VIN="vin" @closeDialog="closeRecordDialog"></vinReqRecord>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import vinSearch from '@/components/business/goods/vinSearchGoods';
import vinReqRecord from '@/components/common/vinReqRecord';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        vinSearch,
        vinReqRecord
    },
    data() {
        return {
            recordVisible:false,
            vinSearchVisible: false,
            summaryStr: '',
            vin: '',
            dateTimes: [],
            source:'',
            searchData: {
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                OrgId: '',
                SIds: [],
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            },
            SIdList: [],
            tableData: [],
            tableDataLength: 0,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dateTimes.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        var source = this.$route.query.source;
        if(source){
            switch(source){
                case "小程序":
                    this.source = "APPLET";
                    break;
                case "微信群":
                    this.source = "QYWX Group";
                    break;
                default :
                    this.source = "YQG_PC";

            }
        }
        this.getTableData();
    },
    methods: {
        renderHeader(h, { column }) {
            const goodsCount = [
                h(
                    'div',
                    {
                        slot: 'content',
                        style: 'margin-bottom:5px'
                    },
                    '仅是绑定单据时系统自动关联车型与配件的总数，'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '不包含在商品新增或编辑页面中主动勾选的关联数'
                )
            ];
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'bottom'
                        }
                    },
                    [
                        goodsCount,
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        // 重置表单
        resetSearch() {
            this.searchData.VIN = '';
            this.searchData.SId = '';
            this.searchData.StartDate = '';
            this.searchData.EndDate = '';
            this.searchData.page = 1;
            this.searchData.limit = this.commonPageSize;
            this.dateTimes = [];
        },
        // 获取数据
        getTableData() {
            if(this.source){
                this.searchData.Source = this.source
            }
            this.$util
                .axiosGet({
                    url: '/api/DataStatistics/VINStatistics',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.tableData = data.DataList;
                        this.tableDataLength = res.count;
                        this.summaryStr = data.SummaryStr;
                    } else if (res.errcode != 201 && !data) {
                        this.tableData = [];
                        this.tableDataLength = 0;
                    }
                })
                .catch(() => {});
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            }
        },
        staffVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length == 0) that.getSIdList();
            }
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        vinSearch(vin) {
            if (vin) {
                this.vin = vin;
                this.vinSearchVisible = true;
            }
        },
        closeVinSearch() {
            this.vinSearchVisible = false;
        },
        opRecords(vin) {
            if(vin){
                this.vin = vin;
                this.recordVisible = true;
            }
        },
        closeRecordDialog(){
            this.vin = '';
            this.recordVisible = false;
        }
    }
};
</script>